// extracted by mini-css-extract-plugin
export default {"headerQuestionNumber":"TryAgain_headerQuestionNumber__3ujiF"};